import { BookOpen, Cpu, HeartPulse, Landmark, Waves } from "lucide-react";
import { DossierLayout } from "@/components/DossierLayout";
import { IMAGES } from "@/data/content";

const DESKS = [
  { id: "climate", icon: Waves, title: "Climate and Environmental Resilience" },
  { id: "health", icon: HeartPulse, title: "Health and Human Development" },
  { id: "governance", icon: Landmark, title: "Governance and Democratic Institutions" },
  { id: "culture", icon: BookOpen, title: "Culture, Identity and History" },
  { id: "innovation", icon: Cpu, title: "Innovation, AI and Economic Transformation" },
];

const DATA = {
  country: "Ghana",
  region: "West Africa",
  subtitle:
    "A living research and editorial asset examining Ghana as a strategic node connecting West Africa, the Caribbean and the global African diaspora. Research and reporting in development.",
  image: IMAGES.ghanaStreet,
  imageAlt: "Busy street in Accra, Ghana",
  brief: null,
  goals: null,
  desks: DESKS,
  projects: null,
  stakeholders: null,
  sources: null,
  plan: null,
  measures: null,
  downloads: [
    { title: "Ghana Country Dossier", note: "PDF · In development", button: "Download Dossier PDF — Coming Soon", testid: "dossier-download-pdf-button" },
    { title: "Ghana–Jamaica Cooperation Tracker", note: "PDF · In development", button: "Download — Coming Soon", testid: "dossier-download-tracker-button" },
  ],
  latestStory: {
    label: "Ghana–Jamaica Relations",
    title: "From Barrier to Bridge: What Ghana and Jamaica Must Build After the Presidential Visit",
    to: "/analysis/ghana-jamaica-presidential-visit",
  },
  editorialStandard:
    "Every output must be evidence-based, human-centred, comparative where useful, solutions-oriented and respectful of local agency. Atlantic Bridge will not treat Ghana as a backdrop for outside interpretation. Ghanaian scholars, journalists, practitioners and communities must be central to the work.",
  cta: {
    kicker: "Country Dossiers",
    title: "The Jamaica Dossier Is Live",
    copy: "Jamaica is the Atlantic Bridge Institute's first full country dossier and the launch point for a wider Caribbean knowledge programme.",
    buttonLabel: "Open the Jamaica Dossier",
    to: "/countries/jamaica",
  },
};

export default function GhanaDossierPage() {
  return <DossierLayout data={DATA} />;
}
